import {ref} from "vue";
import {useLog} from "@/composables/useLog";
import {authFetch} from "@/composables/useAuthFetch";

const log = useLog("useSaveLinkedIn");

async function refreshClerkUser(user) {
  try {
    await window.Clerk?.session?.touch();
    await user.reload();
    log("clerk user refreshed");
  } catch (error) {
    log(`clerk refresh failed: ${error?.message}`);
  }
}

async function postLinkedInUrl(user, linkedInUrl) {
  const body = {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    publicMetadata: {linkedInUrl: linkedInUrl || ""},
    overwrite: true,
  };
  const response = await authFetch("/api/v1/user/update/clerk", {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify(body),
  });
  const data = await response.json();
  return data.ok === true;
}

export function useSaveLinkedIn() {
  const isSaving = ref(false);

  async function save(user, linkedInUrl) {
    if (!user) return false;
    isSaving.value = true;
    try {
      const ok = await postLinkedInUrl(user, linkedInUrl);
      log(`save result: ok=${ok}`);
      if (ok) await refreshClerkUser(user);
      return ok;
    } catch (error) {
      log(`save error: ${error?.message}`);
      return false;
    } finally {
      isSaving.value = false;
    }
  }

  return {isSaving, save};
}
